import React from 'react'
import styles from './CargandoPagina.module.css'
import imgLoaderGeneral from '../../img/2.gif'

const CargandoPagina = ({ history }) => {
    return (
        <div>
            <div className={styles.contenedor} >
                <div className={styles.contenido}>
                    <div className={styles.contenidoFlex}>
                        <img src={imgLoaderGeneral} alt='Cargando' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CargandoPagina